// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"294":"8aa20e19","391":"7283f359","410":"3cc5a6ed","475":"b45190db","712":"0260efd7","772":"b45190db","980":"77d4a999"}[chunkId] + ".chunk.css";
};